export const common = {
	//Menu
	"menu.play": "Play",
	"menu.ranking": "Leaderboard",
	"menu.prizes": "Prizes",
	"menu.rules": "Rules",
	"menu.leagues": "Leagues",
	"menu.betwayAccount": "Betway Account",
	"menu.terms": "T&Cs",

	//Play
	"play.heroTitle": "Predict every match result and win prizes!",
	"play.heroSubtitle": "Which team will win? How many goals will they score? Predict now and compete against your friends!",
	"play.playNow": "Play Now",
	"play.seePrizes": "See Prizes",
	"play.statistics": "Statistics",
	"play.lastMatches": "Last 5 matches of each team",
	"play.stats": "Stats",

	//Ranking
	"ranking.season": "Season",
	"ranking.weekly": "Weekly",
	"ranking.selectType": "Select ranking type",
	"ranking.selectWeek": "Select week",
	"ranking.myPosition": "My position",
	"ranking.points": "Points",
	"ranking.rank": "Rank",
	"ranking.topMembers": "Top 20 members",
	"ranking.noRanking": "No leaderboard yet.",
	"ranking.competitionStart": "Once the competition starts, all users who have played BW Score Predict will rank here.",
	"ranking.loadMore": "Load More",
	"ranking.loading": "Loading...",

	//Leagues
	"leagues.heroTitle": "Compete against your friends or join public leagues!",
	"leagues.heroSubtitle": "Who's got the best prediction skills? Create or join a league to find out!",
	"leagues.createLeague": "Create a league",
	"leagues.joinLeague": "Join a league",
	"leagues.createLeagueButton": "Create league",
	"leagues.joinLeagueButton": "Join league",
	"leagues.enterName": "Enter league name",
	"leagues.enterCode": "Enter invitation code",
	"leagues.myLeagues": "My leagues",
	"leagues.member": "member",
	"leagues.members": "members",
	"leagues.membersCapital": "Members",
	"leagues.league": "League",
	"leagues.shareCodeText": "Your friends can join your league by using this code:",
	"leagues.shareCode": "Share code",
	"leagues.editLeague": "Edit league",
	"leagues.delete": "Delete",
	"leagues.leave": "Leave",
	"leagues.deleteWarning": "All the history and members will be permanently deleted.",
	"leagues.leaveWarning": "Your prediction points and ranking will be deleted.",
	"leagues.confirmDelete": "Yes, delete",
	"leagues.confirmLeave": "Yes, leave",
	"leagues.cancel": "Cancel",
	"leagues.ban": "Ban",
	"leagues.edit": "Edit",
	"leagues.save": "Save",

	//Errors
	"errors.savingPredictions": "Error saving predictions",

	//Predictions
	"predictions.successModal.title": "Predictions Confirmed!",
	"predictions.successModal.subtitle": "Your predictions have been successfully saved!",
	"predictions.successModal.close": "Close",
	"predictions.seasonEnd.title": "Season Complete!",
	"predictions.seasonEnd.message":
		"That's a wrap for this season of BW ScorePredict — great job! Congratulations to our grand prize winner, [username], who won a trip for two to watch Arsenal live at the Emirates Stadium. While the action takes a short break, we're already getting ready for the next round. Stay tuned for updates and prepare to come back with even sharper predictions.",
	"predictions.seasonEnd.subtitle": "We can't wait to have you back in the game!",
	"predictions.seasonEnd.myPosition": "My Position",
	"predictions.seasonEnd.points": "Points",
	"predictions.seasonEnd.rank": "Rank",
	"predictions.seasonEnd.topMembers": "Top 10 members",
	"predictions.countdown.deadline": "Deadline",
	"predictions.countdown.deadlineMissed": "Deadline Missed",
	"predictions.countdown.matchweekDeadline": "Matchweek Deadline",
	"predictions.countdown.deadlineMissedMessage":
		"You didn't make your predictions for this week, so no points were earned - but there's always next week to bounce back!",
	"predictions.countdown.days": "DAYS",
	"predictions.countdown.hours": "HOURS",
	"predictions.countdown.minutes": "MIN.",
	"predictions.countdown.seconds": "SEC.",
	"predictions.bonusFooter.loadingOdds": "Loading odds...",
	"predictions.bonusFooter.draw": "Draw",
	"predictions.bonusFooter.unknown": "Unknown",
	"predictions.bonusFooter.oddsToWin": "Odds to Win",
	"predictions.roundSelector.previousRound": "Previous round",
	"predictions.roundSelector.nextRound": "Next round",
	"predictions.points.totalPoints": "Weekly Points",
	"predictions.points.currentPosition": "Current position",
	"predictions.points.points": "Points",
	"predictions.points.totalPointsLabel": "Total points",
	"predictions.submitButton.submitting": "Submitting...",
	"predictions.submitButton.predictionsSaved": "Predictions Saved",
	"predictions.submitButton.updatePredictions": "Update Predictions",
	"predictions.submitButton.submitAllPredictions": "Submit All Predictions",
	"predictions.predictionCard.result": "Result",
	"predictions.predictionCard.pts": "Pts",

	//Predictions Info Card
	"predictions.infoCard.title": "Predict every match result and win prizes!",
	"predictions.infoCard.description":
		"Who'll come out on top? How many goals will they score? Predict now and compete against your friends! Rules and T&C’s apply.",
	"predictions.infoCard.playButton": "Play Now",
	"predictions.infoCard.prizesButton": "See Prizes",

	//Common Components
	"common.shareCard.title": "Invite Your Friends to Play",
	"common.shareCard.description":
		"Invite your friends to Play BW ScorePredict to see who of you is the best football manager, and for you to all stand a chance of winning weekly prizes!",
	"common.shareCard.button": "Invite Friends",
	"common.shareCard.shareTitle": "Download BetwayScores",
	"common.shareCard.shareBody": "Download BetwayScores and compete against your friends in BW ScorePredict!",

	"common.accessDenied.title": "Download Betway Scores App",
	"common.accessDenied.description":
		"To access this content, please download the Betway Scores app. Get the latest scores, predictions, and exclusive features right at your fingertips.",
	"common.accessDenied.rulesText": "Available for iOS and Android devices. Download now to get started!",
	"common.accessDenied.button": "Download Betway Scores App",

	"common.prizesInfoCard.title": "Info about Prizes",
	"common.prizesInfoCard.description1":
		"You do not need to have a Betway account to play BW ScorePredict, however to redeem a weekly prize for coming in the Top 10 in any week, you need to have a Betway account for those winnings to be deposited into.",
	"common.prizesInfoCard.description2": "See the Rules and Ts & Cs of the game for details of the weekly and overall prizes.",
	"common.prizesInfoCard.button": "See Rules",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Grand Prize – Watch Arsenal at the Emirates Stadium",
	"prizes.prizeCard1.description":
		"Win a trip for two to watch Arsenal play at the Emirates Stadium in London, including flights (if required), accommodation (if required) and £500 spending money.",
	"prizes.prizeCard2.title": "Round Winner – Cash Prize in your Betway account",
	"prizes.prizeCard2.description":
		"The top performer every week will win €150 (or currency equivalent – see ‘Rules’ section) as Cash deposited into their Betway account.",
	"prizes.prizeCard3.title": "Places 2-10 every round – Cash Prize in your Betway account",
	"prizes.prizeCard3.description":
		"Those finishing 2nd to 10th every week will also receive Cash prizes in their Betway account. See the ‘Rules’ section for the exact amounts that you can win.",

	"common.modal.pointsFormat": "+{points}pts",

	//Betway Account Fragment
	"betwayAccount.title": "Open a Betway Account",
	"betwayAccount.description":
		"You do not need to have a Betway account to play BW ScorePredict, however to redeem a weekly prize for coming in the Top 10 in any week, you need to have a Betway account for those winnings to be deposited into.",
	"betwayAccount.rulesText": "See the Rules and Ts & Cs of the game for details of the weekly and overall prizes.",
	"betwayAccount.button": "Open a Betway Account",
};
